import React, { Component } from 'react';
import PartnerCard from "../PartnersPage/PartnerCard";
import { handleRequestError, Request } from '../../../helpers/request'
import { getVariable } from '../../../helpers/variable'
import LocaleLink from '../../Routes/LocaleLink'
import {FormattedMessage} from "react-intl";


class HomepageTrust extends Component
{
    isMounted = false;

    state = {
        variables: null,
        partners: null
    };

    componentDidMount() {
        this.isMounted = true;
        this.fetch();
        this.fetchPartners();

        window.addEventListener('scroll', this.onScroll)
        this.onScroll()
    }

    fetch() {
        Request.get('variables/by-category/partners')
            .then((data) => {
                if (this.isMounted) {
                    this.setState({ variables: data })
                }
            })
            .catch(handleRequestError);
    }

    fetchPartners() {
        Request.get('partners')
            .then((data) => {
                if (this.isMounted) {
                    this.setState({ partners: data })
                }
            })
            .catch(handleRequestError);
    }

    parallax = React.createRef()

    componentWillUnmount() {
        window.removeEventListener('scroll', this.onScroll)
        this.isMounted = false;
    }

    onScroll = (e) => {
        const scrollY = window.scrollY
        const delta = scrollY / this.parallax.current.offsetHeight
        this.parallax.current.style.marginTop = Math.round(100 * delta - 350) + 'px'
    }

    render()
    {
        const hidden = (!this.state.variables || !this.state.partners || this.state.partners.length === 0)

        return (
            <section className="section-trust" style={{ display: hidden ? 'none' : 'block' }}>
                <div className="section-trust-after" ref={this.parallax}/>
                {this.renderContent(hidden)}
            </section>
        )
    }

    renderContent(hidden) {
        if (hidden)
            return null

        return (
            <div className="container">
                <div className="trust-block">
                    <div className="trust-head">
                        <h2>
                            { getVariable(this.state.variables, 'partners.title') }
                        </h2>
                        <p>
                            { getVariable(this.state.variables, 'partners.text') }
                        </p>
                        <ul className="number-list d-flex d-xl-block">
                            <li>
                                <strong>
                                    { getVariable(this.state.variables, 'partners.stats.1.value') }
                                </strong>
                                <h3>
                                    { getVariable(this.state.variables, 'partners.stats.1.label') }
                                </h3>
                            </li>
                            <li>
                                <strong>
                                    { getVariable(this.state.variables, 'partners.stats.2.value') }
                                </strong>
                                <h3>
                                    <FormattedMessage
                                        id="portfolio.homepage.trust.stats.partners.label"
                                        defaultMessage="Recrutements en 2020"
                                    />
                                </h3>
                            </li>
                        </ul>
                    </div>
                    <div className="trusted-brands">
                        {this.renderPartners()}

                        <LocaleLink to="/partenaires" className="btn btn-line-primary">
                            { getVariable(this.state.variables, 'partners.button') }
                        </LocaleLink>
                    </div>
                </div>
            </div>
        )
    }

    renderPartners() {
        const {partners} = this.state;
        return(
            <ul>
                {partners.map((partner, key) => {
                    if(key < 6)
                        return <PartnerCard partner={partner} partners={partners} key={key} key_as_prop={key} animation={true}/>
                })}
            </ul>
        )
    }
}

export default HomepageTrust;
